import axios from "axios";

const API = axios.create({
  baseURL: "https://navith.cloud/api/",
});

// const API = axios.create({
//   baseURL: "http://127.0.0.1:8000/api/",
// });

// REQUEST INTERCEPTOR
API.interceptors.request.use((config) => {
  // ❌ Do NOT attach token for login APIs
  if (
    config.url.includes("/auth/login") ||
    config.url.includes("/school-admin/login")
  ) {
    return config;
  }

  const token = localStorage.getItem("access_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// RESPONSE INTERCEPTOR — auto logout when token expires
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Remove expired token
      localStorage.removeItem("access_token");

      // Redirect to login
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default API;